import { json } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { client } from "../models/contentful.server";
import ComponentBuilder from "@/components/ComponentBuilder";

export async function loader() {
	return json(await client.getPage("Menu"))
}

export const meta = ({data} : any) => {
	const {seoMetadata} = data;
	return {
		title: seoMetadata?.title || 'Cannoli - Italialainen ravintola | Italian food and wine',
		description: seoMetadata?.description || 'Italialainen ravintola | Italian food and wine',
		"og:image": `${seoMetadata?.ogImage.url}`
	}
}

export default function Menu() {
	const { blocksCollection } = useLoaderData();
	return (
		<>
			<ComponentBuilder blocks={blocksCollection?.items} />
		</>
	);
}
